import { Observable } from 'rxjs';

import { AdditionalInformationHttpService } from '@feature/_app_modules/additional-information/services/additional-information-http.service';
import { ApplicationState } from '@feature/store/application-store';
import { Store, select, Action } from '@ngrx/store';
import * as AdditionalInformationSelectors from '../selectors/additional-information.selectors';
import { UdfGroup } from '@feature/_app_modules/additional-information/models/UdfGroups';
import { Details } from '@details/Interfaces/details';
import { SaveAdditionalInformationUserSelectedSectionsRequest, AdditionalInformationRequest } from '../additional-information.types';
import { Injectable } from "@angular/core";

@Injectable()
export class AdditionalInformationFacadeService {
  constructor(
    private readonly additionalDetailsHttpService: AdditionalInformationHttpService,
    private readonly store: Store<ApplicationState>
  ) { }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  isGetAvailableGroupsLoading(widgetConfigId: number): Observable<boolean> {
    return this.store.pipe(select(AdditionalInformationSelectors.getAvailableGroupsLoading(widgetConfigId)));
  }

  getAvailableGroups(widgetConfigId: number): Observable<UdfGroup[]> {
    return this.store.pipe(select(AdditionalInformationSelectors.getAvailableGroups(widgetConfigId)));
  }

  isUserSelectedGroupsLoading(dashboardId: number): Observable<boolean> {
    return this.store.pipe(select(AdditionalInformationSelectors.getUserSelectedGroupsLoading(dashboardId)));
  }

  getUserSelectedGroups(dashboardId: number): Observable<UdfGroup[]> {
    return this.store.pipe(select(AdditionalInformationSelectors.getUserSelectedGroups(dashboardId)));
  }

  getDetails(dashboardId: number): Observable<Details> {
    return this.store.pipe(select(AdditionalInformationSelectors.getAdditionInformationDetails(dashboardId)));
  }

  saveUserSelectedGroups(saveRequest: SaveAdditionalInformationUserSelectedSectionsRequest): Observable<boolean> {
    return this.additionalDetailsHttpService.saveAdditionalInformationUserSections(saveRequest);
  }

  setToDefaults(request: AdditionalInformationRequest): Observable<boolean> {
    return this.additionalDetailsHttpService.setToDefaults(request);
  }
}
